import React from 'react'
import { Image } from 'antd'
import { PictureOutlined } from '@ant-design/icons'

export interface LineItemThumbnailProps {
  imageUrl?: string | null
  alt?: string
  size?: number
}

export const LineItemThumbnail: React.FC<LineItemThumbnailProps> = ({
  imageUrl,
  alt = '',
  size = 36,
}) => {
  const url = imageUrl?.trim()
  if (!url) {
    return (
      <div
        style={{
          width: size,
          height: size,
          borderRadius: 4,
          background: '#f5f5f5',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          color: '#bfbfbf',
        }}
        aria-hidden
      >
        <PictureOutlined style={{ fontSize: Math.max(14, size * 0.4) }} />
      </div>
    )
  }

  return (
    <Image
      src={url}
      alt={alt}
      width={size}
      height={size}
      style={{ objectFit: 'cover', borderRadius: 4, flexShrink: 0 }}
      preview={false}
    />
  )
}

export const LineItemNameWithThumbnail: React.FC<{
  name: React.ReactNode
  imageUrl?: string | null
  description?: React.ReactNode
  size?: number
}> = ({ name, imageUrl, description, size = 36 }) => (
  <div style={{ display: 'flex', alignItems: 'flex-start', gap: 8, minWidth: 0 }}>
    <LineItemThumbnail imageUrl={imageUrl} alt={typeof name === 'string' ? name : ''} size={size} />
    <div style={{ flex: 1, minWidth: 0 }}>
      {name}
      {description}
    </div>
  </div>
)
